import React from 'react';
import T from 'prop-types';
import { isEmpty, map, upperCase } from 'lodash-es';

import WarningNotification from '../WarningNotification';
import CheckboxGroup from '../../../CheckboxGroup';
import Tooltip from '../../../Tooltip';

import { groupedSegmentsOptions } from '../../configs/report';
import { AI_COHORTS_TOOLTIPS } from '../../../../utils/advanced-metrics';

const UserSegments = ({
  active,
  panelVersion,
  activeDataPoints,
  disabledNotCrossApp,
  onChange,
}) => {
  const renderTooltip = (group, options) => {
    let tooltipContent = null;

    if (group === 'ai_segments') {
      tooltipContent = (
        <div className="user-ai-segments-tooltip-content">
          {options.map((option) => (
            <div key={option.value}>
              <h6 className="h6">{option.text}</h6>
              <p>{AI_COHORTS_TOOLTIPS[option.value]}</p>
            </div>
          ))}
        </div>
      );
    }

    return tooltipContent ? (
      <Tooltip
        content={tooltipContent}
        colorVariant="light"
        overlayClassName="user-segments-tooltip"
      >
        <span className="hicon-question-circle" />
      </Tooltip>
    ) : null;
  };

  const groupedOptions = groupedSegmentsOptions(panelVersion, disabledNotCrossApp);

  return (
    <section className="export-settings-section user-segments-section">
      <div className="export-settings-section__content">
        <h5 className="h5 export-settings-section__content-title">User Segments</h5>
        <div className="user-segments-section__groups">
          {map(groupedOptions, (options, group) => (
            <div key={group} className="user-segments-section__group">
              <h6 className="user-segments-section__group-title eyebrow">
                {upperCase(group)}
                {renderTooltip(group, options)}
              </h6>
              <CheckboxGroup
                id={`user-segments-checkboxes-${group}`}
                active={active}
                options={options}
                className="export-settings-section__options export-form-checkbox-group user-segments-options m-b-xs"
                gapCheckbox="8px"
                size="lg"
                onChange={onChange}
              />
            </div>
          ))}
        </div>

        {isEmpty(active) && (
          <WarningNotification text="At least one user segment must be selected" />
        )}
        {!isEmpty(activeDataPoints?.filter((item) => item.startsWith('cross_app'))) &&
          !active.some((a) => a === 'all_users') && (
            <WarningNotification text="For Cross-App reports, 'All Users' must be selected" />
          )}
      </div>
    </section>
  );
};

UserSegments.propTypes = {
  active: T.array.isRequired,
  panelVersion: T.string.isRequired,
  activeDataPoints: T.array.isRequired,
  onChange: T.func.isRequired,
  disabledNotCrossApp: T.bool.isRequired,
};

export default UserSegments;
